import { Check, AlertCircle, Loader2 } from "@/components/icons";

type LookupState = "idle" | "loading" | "valid" | "invalid";

interface ZipStatusIndicatorProps {
  lookupState: LookupState;
  displayInfo: string | null;
}

export function ZipStatusIndicator({
  lookupState,
  displayInfo,
}: ZipStatusIndicatorProps) {
  return (
    <>
      {lookupState === "loading" && (
        <Loader2 className="absolute right-2 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground animate-spin" />
      )}
      {lookupState === "valid" && (
        <Check className="absolute right-2 top-1/2 -translate-y-1/2 w-4 h-4 text-success-strong" />
      )}
      {lookupState === "invalid" && (
        <AlertCircle className="absolute right-2 top-1/2 -translate-y-1/2 w-4 h-4 text-warning-strong" />
      )}
      {displayInfo && (
        <div className="absolute left-0 top-full mt-1 text-xs text-muted-foreground whitespace-nowrap">
          {displayInfo}
        </div>
      )}
    </>
  );
}
